import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	doneNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.todo-item.done-non-final',
		defaultMessage: 'Done',
		description: 'Label of check icon',
	},
	todoNonFinal: {
		id: 'eoc-changeboarding.transition-home.right.todo-item.todo-non-final',
		defaultMessage: 'To do',
		description: 'Label of empty circle icon',
	},
});
